export type TLongPressPoint = { x: number; y: number };

export const getPoint = (event: Event): TLongPressPoint | null => {
  const touch = (event as TouchEvent).touches?.[0] ?? (event as TouchEvent).changedTouches?.[0];

  if (touch) {
    return { x: touch.clientX, y: touch.clientY };
  }

  const mouseEvent = event as MouseEvent;

  if (typeof mouseEvent.clientX === 'number') {
    return { x: mouseEvent.clientX, y: mouseEvent.clientY };
  }

  return null;
};
